export const SUPPORT_EMAIL = 'support@unit21.ai';
